import React, { useState } from 'react'

import langs from '../../assets/allLangs.json'
import Selector from '../AIBuilderTranslations/MultipleLanguageSelector'

const languages = Object.keys(langs).map(key => ({
  code: key,
  language: langs[key],
}))

function MultipleLanguagesSelector({ selectedLanguages = [], setSelectedLanguages = () => {}, multiple = false }) {
  const [selectedOption, setSelectedOption] = useState(null)
  const handleAdd = option => {
    if (!option) return
    const optionToAdd = option || selectedOption

    setSelectedLanguages(optionToAdd)
    setSelectedOption(null)
  }

  const handleSelectedOption = option => {
    setSelectedOption(option)
    handleAdd(option)
  }

  const handleRemoveOption = option => {
    setSelectedLanguages(selectedLanguages.filter(lang => lang.code !== option.code))
  }

  return (
    <Selector
      handleAdd={handleAdd}
      handleRemoveOption={handleRemoveOption}
      multiple={multiple}
      options={languages}
      selectedOption={selectedOption}
      setSelectedOption={handleSelectedOption}
      values={selectedLanguages}
    />
  )
}

export default MultipleLanguagesSelector
